import { FC } from "react";
import { Path, useLocation, Navigate } from "react-router-dom";
import { preserveQueryParams } from "src/lib/createAppPath";

const RedirectWithQueryParams: FC<{ to: Path | string }> = ({ to }) => {
  const location = useLocation();
  const targetPath = typeof to === "string" ? to : to.pathname || "";
  const redirectPath = preserveQueryParams(targetPath, location.search);
  return <Navigate to={redirectPath} replace />;
};

export default RedirectWithQueryParams;
